import Vue from 'vue'
import VueRouter from 'vue-router'

import Dashboard from '@/views/tableau-de-bord'
import AdminDashboard from '@/views/tableau-de-bord/dashboard-admin';
import InfirmierDashboard from '@/views/tableau-de-bord/dashboard-infirmier';
import MedecinDashboard from '@/views/tableau-de-bord/dashboard-medecin';
import LaboratinDashboard from '@/views/tableau-de-bord/dashboard-laboratin';

import AddPatient from '@/views/addPatient'
import Patients from '@/views/listePatient'
import PatientInfo from '@/views/patientInfo'

import AjouterAnalyse from '@/views/creerAnalyse'
import ListeAnalyse from '@/views/listeAnalyse'
import ListeModelesAnalyse from '@/views/modeles-analyses/liste';

import CreerModifierModeleAnalyse from '@/views/modeles-analyses/editer';

import SaisieResultasAnalyse from '@/views/analyse/resultats-analyses/saisie-resultats';

import EditerAnalyse from '@/views/editerAnalyse'
import RegistreOthers from '@/views/analyse/others-registre';

import CreerDossier from '@/views/dossierMedical/create'
import Login from '@/views/login'
import store from '@/store'
// >>>>>>>> Consultations
import SalleAttente from '@/views/consultations/salle-attente'

// ========================================>Medecine Du Travail<==============================
// SOCIETE
import ListeSociete from '@/views/mdt/societe/listeSociete'
import CreerSociete from '@/views/mdt/societe/creerSociete'
import SocieteDetails from '@/views/mdt/societe/societeDetails'

import Facturation from '@/views/mdt/facturations/facturations';
import VisitePoste from '@/views/mdt/visite-postes/visite-postes';
import VisiteMedicale from '@/views/mdt/visite-medicales/visite-medicales';
import ParamVisiteMedicale from '@/views/mdt/visite-medicales/parametrages-globaux';
import CategorieVisiteMedicale from '@/views/mdt/visite-medicales/categories'
import VisiteMedicaleListWrapper from '@/views/mdt/visite-medicales/categories/category-wrapper'
import AccidentMaladie from '@/views/mdt/accidents-maladies-pro/accident-maladie-pro';
import Rapport from '@/views/mdt/rapports/rapports';
import TravailleurInfo from '@/views/mdt/travailleurs/travailleur-info';
import Certificats from '@/views/mdt/certificats'
import DocumentUnique from '@/views/mdt/document-unique'
// ========================================>Medecine Du Travail<==============================

// ===============          PARAMETRES          ==============
import Parametres from '@/views/parametres'
import Assurances from '@/views/parametres/assurances'
import ListeSouscripteurs from '@/views/parametres/assurances/liste-assures'
import Souscripteur from '@/views/parametres/assurances/liste-assures/assure-detail'
import TarificationCatOnmt from '@/views/parametres/tarifications'
import AssuranceGroupes from '@/views/parametres/assurances/assurance-groupes'
import AssuranceGroupeList from '@/views/parametres/assurances/assurance-groupe-list'
import AssureurDetail from '@/views/parametres/assurances/liste-assures/assureur-detail'
import ParamExamensCliniques from '@/views/parametres/examens-cliniques'
import Champ from '@/views/parametres/champs'
import ChampSpecialite from '@/views/parametres/champs/champ-specialite'
import AccesConsultations from '@/views/parametres/accessibilites/acces-consultations'
import AccesExamens from '@/views/parametres/accessibilites/acces-examens'

import PendingResultVisitesMedicales from '@/views/analyse/pending-visites-medicales'
import Resultats from '@/views/analyse/pending-visites-medicales/resultats'
import TarifAdmissions from '@/views/parametres/tarif-admissions'
import TarifActes from '@/views/parametres/tarif-actes'

import PorterResultatExamen from '@/views/examens'
import RegistreExamen from '@/views/examens/registre'
import ExamenAttenteInterpretations from '@/views/examens/attente-interpretations'  
import SalleExamen from '@/views/examens/salle-examen'
import RegistreAnalyse from '@/views/analyse/registre_analyse'
import StatDiagnostiques from '@/views/consultations/statistique-diagnostiques'
import SalleAdmission from '@/views/consultations/admissions'

import Configs from '@/views/parametres/configs'
import Profil from '@/views/parametres/profil'
import BlockedUI from '@/components/blocked-ui'


Vue.use(VueRouter)

const routes = [
    {
        path: '/blocked',
        name: 'Access Denied',
        component: BlockedUI,
    },

    {
        path: '/',
        name: 'Index',
        redirect: '/dashboard'
    },
    {
        path: '/dashboard',
        name: 'Tableau de bord',
        component: Dashboard,
    },
    {
        path: '/dashboard-admin',
        name: 'Administrateur',
        component: AdminDashboard,
    },
    {
        path: '/dashboard-admin',
        name: 'Infirmier',
        component: InfirmierDashboard,
    },
    {
        path: '/dashboard-admin',
        name: 'Medecin',
        component: MedecinDashboard,
    },
    {
        path: '/dashboard-admin',
        name: 'Laboratin',
        component: LaboratinDashboard,
    },
    {
        path: '/dashboard/salle-attente',
        name: 'Salle d\'attente',
        component: SalleAttente,
    },
    {
        path: '/patients/ajouter/:patient_id',
        name: 'AjouterPatient',
        component: AddPatient
    },
    {
        path: '/patients',
        name: 'liste-patients',
        component: Patients
    },
    {
        path: '/patients/:id/:consultation',
        name: 'patientInfo',
        component: PatientInfo,
        props: true,
        children: [
            
        ]
    },
    {
        path: '/analyses/ajouter',
        name: 'creerAnalyse',
        component: AjouterAnalyse
    },
    {
        path: '/parametres/champs',
        name: 'Champs',
        component: Champ
    },
    {
        path: '/parametres/champs/access-par-specialite',
        name: 'Accès Champ',
        component: ChampSpecialite
    },

    {
        path: '/parametres/accessibilite/consultations',
        name: 'Accès Consultations',
        component: AccesConsultations
    },
    {
        path: '/parametres/accessibilite/examens',
        name: 'Accès Examens',
        component: AccesExamens
    },

    {
        path: '/parametres/analyses',
        name: 'listeAnalyse',
        component: ListeAnalyse
    },
    
    {
        path: '/parametres/modeles-analyses',
        name: 'listeModelesAnalyse',
        component: ListeModelesAnalyse,
    },

    {
        path: '/parametres/modeles-analyses/:id(\\d+)?/:action(creer|editer)',
        name: 'creerModifierModeleAnalyse',
        component: CreerModifierModeleAnalyse,
    },

    {
        path: '/analyses/:analyseId/patients/:patientId/resultats',
        name: 'saisie-resultats-analyse',
        component: SaisieResultasAnalyse
    },

    {
        path: '/analyses/editer/:id',
        name: 'editerAnalyse',
        component: EditerAnalyse
    },
    {
        path: '/analyses/registre-others/:analyse_id',
        name: 'Registre others',
        component: RegistreOthers
    },
    {
        path: '/login',
        name: 'login',
        component: Login
    },
    {
        path: '/patients/:id/creer-dossier-medical',
        name: 'dossier_create',
        component: CreerDossier
    },

    {
        path: '/examens/registre',
        name: 'Registre examen',
        component: RegistreExamen
    },

    {
        path: '/examens/interpreter',
        name: 'Attente interpretation',
        component: ExamenAttenteInterpretations
    },
    {
        path: '/examens/salle-examen/:examen_id',
        name: 'Salle examen',
        component: SalleExamen
    },

    {
        path: '/examens/porter-resultat',
        name: 'Porter résultat',
        component: PorterResultatExamen
    },

    {
        path: '/registre/analyses',
        name: 'Registre Analyse',
        component: RegistreAnalyse
    },
    // +++++++++++++        MEDECINE DU TRAVAIL     +++++++++++++++
    // {
    //     path: '/societes',
    //     name: 'Societe',
    //     component: Societe
    // },
    {
        path: '/facturations',
        name: 'Facturation',
        component: Facturation
    },
    {
        path: '/visites-de-postes',
        name: 'VisitePoste',
        component: VisitePoste
    },
    {
        path: '/visite-medicales/resultats/pending',
        name: 'VisiteMedicalePendingResult',
        component: PendingResultVisitesMedicales
    },
    {
        path: '/visite-medicales/resultats/pending/:id',
        name: 'VisiteMedicalePendingResultList',
        component: Resultats
    },
    {
        path: '/visite-medicales',
        name: 'VisiteMedicale',
        component: VisiteMedicale
    },
    {
        path: '/visite-medicales/parametrages',
        name: 'ParamVisiteMedicale',
        component: ParamVisiteMedicale
    },
    {
        path: '/visite-medicales/categories',
        name: 'categorieVisiteMedicale',
        component: CategorieVisiteMedicale
    },
    {
        path: '/visite-medicales/categories/:id',
        name: 'categorieVisiteMedicaleItems',
        component: VisiteMedicaleListWrapper
    },
    {
        path: '/accident-maladie-pro',
        name: 'AccidentMaladie',
        component: AccidentMaladie
    },
    {
        path: '/rapports',
        name: 'Rapport',
        component: Rapport
    },
    {
        path: '/certificats',
        name: 'Certificats',
        component: Certificats
    },
    {
        path: '/document-unique',
        name: 'DocumentUnique',
        component: DocumentUnique
    },

    {
        path: '/societes',
        name: 'liste_societes',
        component: ListeSociete
    },
    {
        path: '/societes/creer-societe',
        name: 'creer_societes',
        component: CreerSociete
    },
    {
        path: '/societes/:id',
        name: 'profilSociete',
        component: SocieteDetails
    },
    {
        path: '/societes/:id/:params',
        name: 'Parametrage_Societe',
        component: SocieteDetails
    },
    {
        path: '/societes/:id/:travailleurs',
        name: 'profilSocieteSections',
        component: SocieteDetails
    },
    {
        path: '/travailleur/:travailleur_id',
        name: 'TravailleurInfo',
        component: TravailleurInfo
    },

    // +++++++++    Paramètres      ++++++++++++
    {
        path: '/parametres',
        name: 'Parametres',
        component: Parametres
    },
    {
        path: '/parametres/assurances',
        name: 'Assurances',
        component: Assurances
    },
    {
        path: '/parametres/assurances/groupe/:id',
        name: 'Groupe Assurance',
        component: AssuranceGroupes,
    },
    {
        path: '/parametres/groupe-assurance',
        name: 'Groupe Assurance',
        component: AssuranceGroupeList,
    },
    {
        path: '/parametres/assureur/:id',
        name: 'Assureur',
        component: ListeSouscripteurs
    },
    {
        path: '/parametres/assureur/:id/souscripteur/:assure_id',
        name: 'Souscripteur',
        component: Souscripteur
    },
    {
        path: '/parametres/assureur/:id/detail/souscripteur/:assure_id',
        name: 'Souscripteur',
        component: AssureurDetail
    },

    // >>>>>>>>>        PARAM Tarification 
    {
        path: '/parametres/tarification-cat-onmt',
        name: 'TarificationCatOnmt',
        component: TarificationCatOnmt
    },
    {
        path: '/parametres/examens-cliniques',
        name: 'ExamensCliniquesParam',
        component: ParamExamensCliniques
    },
    {
        path: '/parametres/tarif-admissions',
        name: 'TarifAdmissions',
        component: TarifAdmissions
    },
    {
        path: '/parametres/tarif/acte-soins',
        name: 'TarifActes',
        component: TarifActes
    },

    // STATS DIAGNOSTICS
    {
        path: '/dashboard/statistiques-sante',
        name: 'Statistique Santé',
        component: StatDiagnostiques
    },

    {
        path: '/parametres/configs',
        name: 'Configurations',
        component: Configs
    },

    {
        path: '/parametres/profil',
        name: 'Profil',
        component: Profil
    },

    {
        path: '/admissions',
        name: 'Profil',
        component: SalleAdmission
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    let access = false;
    let role;
    let role_actif
    if (store.getters['authInfo']) {
        role = store.getters['authInfo'].roles
        access = false
        for (let index = 0; index < role.length; index++) {
            if (
                role[index].nom == "ROLE_INFIRMIER" || role[index].nom == "ROLE_MEDECIN" ||
                role[index].nom == "ROLE_ADMINISTRATEUR" || role[index].nom == "ROLE_TECH_SUP_LABO" ||
                role[index].nom == "ROLE_MEDECIN_TRAVAIL" || role[index].nom == "ROLE_SAGE_FEMME" || 
                role[index].nom == "ROLE_INFIRMIER_MEDECINE_TRAVAIL" || role[index].nom == "ROLE_TECHNICIEN_IMAGERIE" || 
                role[index].nom == "ROLE_RADIOLOGUE"
            ) {
                if (store.getters['activeRole']) {
                    role_actif = store.getters['activeRole'].nom
                    if (
                        role_actif != 'ROLE_INFIRMIER' && role_actif != 'ROLE_MEDECIN' && role_actif != 'ROLE_TECH_SUP_LABO' &&
                        role_actif != 'ROLE_ADMINISTRATEUR' && role_actif != 'ROLE_MEDECIN_TRAVAIL' && 
                        role_actif != 'ROLE_SAGE_FEMME' && role_actif != 'ROLE_INFIRMIER_MEDECINE_TRAVAIL' && role_actif != 'ROLE_TECHNICIEN_IMAGERIE' && 
                        role_actif != 'ROLE_RADIOLOGUE'
                    ) {
                        if (role[index].pivot.is_active != true || role[index].pivot.is_active != '1' || role[index].pivot.is_active != 1) {
                            store.dispatch('switchRole', { userId: store.getters['authInfo'].id, roleId: role[index].pivot.role_id })
                        }
                    }
                } else {
                    if (role[index].pivot.is_default == 1) {
                        store.dispatch('switchRole', { userId: store.getters['authInfo'].id, roleId: role[index].pivot.role_id })
                    }
                }
                
                access = true
                break;
            } else
                access = false
        }


    }
    if (!store.getters['authInfo'] && to.name != 'login') {
        localStorage.clear();
        router.push('/login')
    } else if (access === false && to.name != 'login') {
        localStorage.clear();
        router.push('/login')
    } else {
        // const user_info = store.getters['authInfo']
        
        // const can_login = user_info?.can_login
        
        // if (can_login && can_login == 1) {
            let countdown = {}
            store.dispatch('getCountDown').then((response) => {
                countdown = response
                if (countdown.is_count == 1 && countdown.duree_restant.days < 0) {
                    router.push('/blocked')
                } 
            })
        // }
        store.dispatch('getConfigInfoClinique', 'info_clinique')
        next()
    }
})

/**
 * Prevent right-click context menu.
 */
document.addEventListener('contextmenu', event => event.preventDefault());

/**
 * Prevent F12 key and other developer tool shortcuts.
 */
document.onkeydown = function (e) {
    // F12
    if (e.keyCode === 123) {
        return false;
    }
    // Ctrl+Shift+I
    if (e.ctrlKey && e.shiftKey && e.keyCode === 'I'.charCodeAt(0)) {
        return false;
    }
    // Add other shortcuts as needed
};

export default router